import { render, staticRenderFns } from "./payStepHeader.vue?vue&type=template&id=71563c8e&scoped=true"
import script from "./payStepHeader.vue?vue&type=script&lang=js"
export * from "./payStepHeader.vue?vue&type=script&lang=js"
import style0 from "./payStepHeader.vue?vue&type=style&index=0&id=71563c8e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71563c8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71563c8e')) {
      api.createRecord('71563c8e', component.options)
    } else {
      api.reload('71563c8e', component.options)
    }
    module.hot.accept("./payStepHeader.vue?vue&type=template&id=71563c8e&scoped=true", function () {
      api.rerender('71563c8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ordercenter/components/payStepHeader.vue"
export default component.exports